import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import ListingSection from '../ListingSection';
import ListingSectionItem from '../ListingSectionItem';

/**
 * This component is used to render a skeleton for the vehicles section of the listing page.
 * @returns {React.JSX.Element}
 */

const SectionVehiclesMaybeLoadingSkeleton = () => (
  <ListingSection>
    <ListingSectionItem>
      <Skeleton height="180px" sx={{ borderRadius: 2 }} variant="rounded" width="100%" />
    </ListingSectionItem>
  </ListingSection>
);

export default SectionVehiclesMaybeLoadingSkeleton;